module.exports = __webpack_public_path__ + "img/proceed.c0524e74.svg";